import { useRouter } from 'next/router';
import Image from 'next/image';
import { H2, P } from '../Text';
import { SolidButton, TransparentButton } from '../Button';
import { failureIllustration as unSucessfulPurchaseIcon } from 'assets/illustrations';
import { useTranslation } from 'next-i18next/pages';

import BaseModal from './BaseModal';
import { findKeyByRewriteUrl } from 'urlTranslations';
import { useAuthContext } from 'context/AuthContext';

interface Props {
  closeModal: () => void;
  onSubmit: () => void;
  modalOpen: boolean;
  message: string;
  urlId?: string;
}

const UnsuccessfulPurchaseModal: React.FC<Props> = ({
  closeModal,
  onSubmit,
  modalOpen,
  message,
  urlId,
}) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { authUser: user } = useAuthContext();

  return (
    <BaseModal
      modalOpen={modalOpen}
      closeModal={closeModal}
      cancelDisabled
      isPurchaseStatusModal>
      <div className="flex flex-col sm:flex-row items-center justify-center p-4">
        <div className="flex justify-center items-center flex-1 sm:mr-4">
          <div className="w-48 xs:w-64 h-full">
            <Image
              src={unSucessfulPurchaseIcon}
              alt=""
              className="w-full h-full mx-auto"
            />
          </div>
        </div>
        <div className="flex-1 mt-2 sm:mt-0">
          <H2
            className={`font-medium text-[#ec003e] w-full sm:text-left`}
            centered>
            <b>{t('Unsuccessful payment!')}</b>
          </H2>
          <P className="text-gray-500 mt-2 sm:text-left" centered>
            {message}
          </P>
          <div className="flex flex-col smallmedium:flex-row justify-center smallmedium:space-x-4 sm:justify-start mt-3 sm:mt-0">
            <SolidButton
              className="mt-4"
              onClick={() => {
                onSubmit();
                router.push(
                  `${findKeyByRewriteUrl('/bookings/', router.locale)}${
                    urlId && (!user || user?.isAnonymous) ? `?id=${urlId}` : ''
                  }`,
                );
              }}>
              {t('My bookings')}
            </SolidButton>
            <TransparentButton
              className="mt-4"
              onClick={() => {
                onSubmit();
                router.push('/');
              }}>
              {t('Main page')}
            </TransparentButton>
          </div>
        </div>
      </div>
    </BaseModal>
  );
};

export default UnsuccessfulPurchaseModal;
